(function () {
    'use strict';

    // Defines a Smart Table header with named columns.
    // Usage:

    // Creates:
    //  <smart-header collection="vm.someCollection">
    //  <table><tr><th></th>...<th></th></tr></table>
    //  </smart-header>
    angular.module('blocks.smart').directive('customSmartTable', customSmartTable);

    /* @ngInject */
    function customSmartTable() {

        var directive = {
            scope: {
                items: '=',
                getItems: '=',
                tableName: '=',
                tableConfig: '=',
                datePickerOptions: '='              
            },
            //required in 1.3+ with controllerAs
            bindToController: true,
            controller: controller,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'app/blocks/smart-table-controls/templates/custom-smart-table.html'
        };
        return directive;
        /* @ngInject */
        function controller(PermissionStrategies) {
            /* jshint validthis: true */
            var vm = this;
            vm.PermissionStrategies = PermissionStrategies;
            vm.loadingMessage = 'No ' + vm.tableName + '\'s found ...';
            vm.isFilterCollapsed = true;
            vm.isLoading = true;
            vm.loadItems = loadItems;
            vm.numberOfPages = 1;
            vm.limitDropDown = limitDropDown;

            function loadItems(tableState) {
                vm.loadingMessage = 'Loading ... ';
                vm.isLoading = true;
                vm.numberOfPages = 1;
                return vm.getItems(tableState)
                    .then(function (rows) {
                        if (rows.constructor === Array) {
                            vm.items = rows;
                            if (rows.count === 0) {
                                vm.loadingMessage = 'No ' + vm.tableName + '\'s found ...';
                            }
                            if (!!tableState) {
                                tableState.pagination.numberOfPages =
                                    Math.ceil(rows.count / tableState.pagination.number);
                                vm.numberOfPages = tableState.pagination.numberOfPages;
                            } else {
                                tableState.pagination.numberOfPages = 1;
                                tableState.pagination.totalItemCount = rows.length;
                            }
                        } else if (rows.data.value.count !== 0) {
                            vm.items = rows.data.value;
                            if (rows.data.count === 0) {
                                vm.loadingMessage = 'No ' + vm.tableName + '\'s found ...';
                            }
                            if (!!tableState) {
                                tableState.pagination.numberOfPages =
                                    Math.ceil(rows.data.count / tableState.pagination.number);
                                vm.numberOfPages = tableState.pagination.numberOfPages;
                            } else {
                                tableState.pagination.numberOfPages = 1;
                                tableState.pagination.totalItemCount = rows.length;
                            }
                        } else {
                            vm.loadingMessage = 'No ' + vm.tableName + '\'s found ...';
                        }
                    }).catch(function () {
                        vm.items = [];
                        if (!!tableState) {
                            tableState.pagination.totalItemCount = 0;
                            tableState.pagination.numberOfPages = 1;
                        }
                        vm.loadingMessage = 'No ' + vm.tableName + '\'s found ...';
                    }).finally(function () {
                        vm.isLoading = false;
                        vm.loadingMessage = vm.loadingMessage = 'No ' +
                            vm.tableName + '\'s found ...';
                    });
            }

            function limitDropDown(action, row) {
                if (!!action.filterDropDown) {
                    return action.filterDropDown(row);
                }
                return true;
            }
        }
        /* @ngInject */
        function link() {
            
        }
    }
})();
